import { render } from "./InterventionsPreventivesTab.vue?vue&type=template&id=457ed437&scoped=true&ts=true"
import script from "./InterventionsPreventivesTab.vue?vue&type=script&lang=ts"
export * from "./InterventionsPreventivesTab.vue?vue&type=script&lang=ts"

import "./InterventionsPreventivesTab.vue?vue&type=style&index=0&id=457ed437&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457ed437"]])

export default __exports__